import { gql } from '@apollo/client';

export const GET_USER = gql`
  query getUser($uid: String) {
    user(uid: $uid) {
      uid
      email
      name {
        first
        last
        display
        lowercase
      }
      phoneNumber
      created
      lastLogin
      admin
      companies
      address {
        street1
        street2
        city
        state
        zip
        country
      }
      dateOfBirth
      gender
      directDeposit {
        last4
        accountType
        accountHolderName
      }
      acceptedPrivacyPolicy
      acceptedTermsOfService
    }
  }
`;

export const GET_MARKETPLACE_SERVICES = gql`
  query getMarketplaceServices($uid: String) {
    marketplaceServices(uid: $uid) {
      id
      serviceName
      serviceCategory
      serviceProvider
      tileHeader
      tileBodyText
      CTAButton
      CTAButtonText
      CTAButtonURL
      redeemCode
      phoneButton
      phoneNumber
      fontColor
      tilesVisibility
      isActive
      createdAt
      headerPhoto {
        name
        path
        type
      }
      logoFile {
        name
        path
        type
      }
    }
  }
`;
